import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild, EventEmitter} from '@angular/core';
import {Router} from "@angular/router";
import {SwitchBoard} from "../services/SwitchBoard";
import {StateService} from "../services/StateService";
import {Session} from "../services/Session";
import {CommonModule} from "@angular/common";
import {State} from "../models/State";
import {TOAST_TYPE} from "../constants/Tpiq.constants";
import {LoadingService} from "../services/LoadingService";
import {LoginService} from "../services/Login.service";
import {ToastService} from "../services/Toast.service";
import {TaxPlanningService} from "../tpiq-services/tax-planning.service";
import {takeUntil} from "rxjs/operators";
import {FormsModule} from "@angular/forms";
import {FoundationInit} from "../directives/foundation.directive";

declare var jQuery: any;
declare var _: any;
declare const moment: any;

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, FormsModule, FoundationInit],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  isSideMenuExpanded = false;
  searchText: any;
  amount = 0;
  title: string;
  user: any;
  accounts: Array<any> = [];
  showReconnecting: boolean;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  org: any;
  @ViewChild('tpiq') logoutTitle: ElementRef;
  @ViewChild('apps') appsPanel: ElementRef;
  taxPlanningTerms: any;
  subscriptionStatus: string;
  currentPlan: string;
  onboardStatus: any;

  constructor(private _router: Router, private switchBoard: SwitchBoard, private stateService: StateService,
              private loadingService: LoadingService, private loginService: LoginService,
              private _toastService: ToastService, private taxPlanningService: TaxPlanningService) {

    this.searchText = '';
    let status: any = Session.get('user').onboardingStatus;
    this.onboardStatus = (status) ? status : 'Done';
    this.user = Session.getUser();
    this.org = Session.getOrg() ? Session.getOrg() : '';
    this.getTermsInfo();

    this.switchBoard.onRefresh.pipe(takeUntil(this.destroy$)).subscribe(reload => {
      this.refreshToken();
    });

    this.switchBoard.onUserOnboard.pipe(takeUntil(this.destroy$))
      .subscribe(obj => {
        let status: any = Session.get('user').onboardingStatus;
        this.onboardStatus = (status) ? status : 'Done';
      });

    this.switchBoard.onSideBarExpand.pipe(takeUntil(this.destroy$)).subscribe(flag => {
      this.isSideMenuExpanded = flag;
    });

    this.taxPlanningService.getSubscriptionStatus(this.org, this.user.id).subscribe(response => {
      this.subscriptionStatus = response.subscriptionStatus;
      this.currentPlan = response.plan;
    });
  }

  getTermsInfo() {
    this.taxPlanningService.getTermsAndConditions(Session.getOrg(), this.user.id).subscribe(response => {
      this.taxPlanningTerms = response || {};
    });
  }

  logout() {
    this.validateLoginAndRedirect();
  }

  showError(error) {
  }

  ngOnInit() {
    jQuery(document).ready(function() {
      jQuery(document).foundation();
    });
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  refreshToken() {
    this.loadingService.triggerLoadingEvent(true);
    const tokenData = {
      token: Session.getToken(),
      refreshToken: Session.getRefreshToken()
    };
    this.loginService.refreshToken(tokenData).subscribe(data => {
      this.updateToken(data);
    }, error => {
      this.switchBoard.onLogOut.next({});
    });
  }

  updateToken(data) {
    const base = this;
    this.loadingService.triggerLoadingEvent(false);
    Session.removeToken();
    Session.setToken(data.token);
    Session.setRefreshToken(data.refreshToken);
    setTimeout(function() {
      base.loadingService.triggerLoadingEvent(false);
    });
  }

  validateLoginAndRedirect() {
    const data = localStorage.getItem('wall_rm');
    const details = JSON.parse(data);
    if (details && details.rememberMe) {
      localStorage.removeItem('wall_rm');
      this.switchBoard.onLogOut.next({loggedOut: true});
    } else {
      this.switchBoard.onLogOut.next({loggedOut: true});
    }
  }

  showProfile() {
    // this.switchBoard.onHeaderOptionClicked.next();
    this.stateService.addState(new State('', this._router.url, null, null));
    const link = ['tax-planning/profile'];
    this._router.navigate(link);
  }

  openLogoutMenu($event) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    // Close apps menu if open
    if (this.appsPanel.nativeElement.classList.contains('is-open')) {
      jQuery('#apps-dropdown-id').foundation('close');
    }
    // Re-read session user/org so dropdown reflects any recent profile/firm edits
    this.user = Session.getUser();
    this.org = Session.getOrg() ? Session.getOrg() : '';
    jQuery('#logout-menu-dropdown-id').foundation('toggle');
  }

  getUserBadgeName(user) {
    if (user) {
      const firstletter = user.first_name ? user.first_name.charAt(0) : '';
      const lastletter = user.last_name ? user.last_name.charAt(0) : '';
      return firstletter + lastletter;
    }
    return '';
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    const base = this;
    if (this.logoutTitle.nativeElement.classList.contains('is-open')) {
      jQuery('#logout-menu-dropdown-id').foundation('toggle');
    }
    if (this.appsPanel.nativeElement.classList.contains('is-open')) {
      this.toggleApps();
    }
  }

  openAppsMenu($event) {
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    // Close logout menu if open
    if (this.logoutTitle.nativeElement.classList.contains('is-open')) {
      jQuery('#logout-menu-dropdown-id').foundation('close');
    }
    jQuery('#apps-dropdown-id').foundation('toggle');
  }

  toggleApps() {
    jQuery('#apps-dropdown-id').foundation('toggle');
  }

  manageUsers() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/manage-users'];
    this._router.navigate(link);
  }

  manageBilling() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/manageBilling'];
    this._router.navigate(link);
  }

  manageSubscription() {
    this.stateService.addState(new State('', this._router.url, null, null));
    const link = ['tax-planning/manage-subscription'];
    this._router.navigate(link);
  }

  manageLogo() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/manage-logo'];
    this._router.navigate(link);
  }

  manageQuestionnaire() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/manage-questionnaire'];
    this._router.navigate(link);
  }

  manageIntegrations() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/integrations'];
    this._router.navigate(link);
  }

  manageAgreements() {
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.getAgreementsFile(Session.getOrg(), this.user.id).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      if (response) {
          //window.open(response.temporaryURL);
          let org = Session.getOrg();
          const blob = new Blob([response], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = org + '-agreement.pdf';
          a.click();
          window.URL.revokeObjectURL(url);
      }
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      const message = error.message ? error.message : `Agreement not signed`;
      try {
        this._toastService.pop(TOAST_TYPE.error, message);
      } catch (e) {
        this._toastService.pop(TOAST_TYPE.error, message);
      }
    });
  }

  manageGrowthPlan() {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    const link = ['tax-planning/growth-plan'];
    this._router.navigate(link);
  }

  showPage(page) {
    this.stateService.addState(new State('', this._router.url, null, null));
    // this.switchBoard.onHeaderOptionClicked.next();
    this._router.navigate([page]);
  }

}
